export default __webpack_public_path__ + "media/images/Masto-E2-Duo-Dos-c00f4ac956f4118acffb6e5eb71db6dc.png";